import React, { useEffect } from 'react'
import { FormattedHTMLMessage } from 'gatsby-plugin-intl';
import styled from 'styled-components';
import { device } from "../device";
import { PlainImage } from '../imageComponents';
import Modal from 'react-modal';
import cursor from '../../icons/Cursors/close_cursor.png'
import BackButtonWithIcon from '../styledComponents/BackButtonWithIcon';
import ChevronButton from '../styledComponents/ChevronButton';

const HeaderPopup = styled.div`
    background-color: #000;
    position: relative

`
const HeaderTitle = styled.div`
    color: var(--light-gray1);
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    margin-bottom: 8px;
    text-align: center;
    @media ${device.sm} {
        font-size: 40px;
        line-height: 48px;
    }
    @media ${device.xl} {
        font-size: 48px;
        line-height: 56px;
    }
`
const HeaderSubTitle = styled.div`
    color: var(--midle-gray4);
    font-size: 12px;
    font-weight: 300;
    line-height: 16px;
    text-align: center;
    @media ${device.sm} {
        font-size: 16px;
        letter-spacing: .5px;
        line-height: 24px;
    }
    @media ${device.xl} {
        font-size: 18px;
        line-height: 30px;
        padding: 0 64px;
    }
`
const HeaderWrapper = styled.div`
    align-items: center;
    bottom: 8px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
    position: absolute;
    // top: 0;
    width: 100%;
    @media ${device.sm} {
        bottom: 32px;
    }
    @media ${device.xl} {
        bottom: 40px;
    }
`
const ContentBlock = styled.div`
    padding: 24px 16px 80px;
    @media ${device.sm} {
        padding: 48px 50px;
    }
`
const ContentSubBlock = styled.div`
    margin-bottom: 48px;
`
const BlockTitle = styled.div`
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 8px;
    @media ${device.sm} {
        font-size: 32px;
        margin-bottom: 24px;
    }
`
const BlockParagraph = styled.div`
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    @media ${device.sm} {
        font-size: 14px;
        line-height: 20px;
    }
`
const BlockParagraphLast = styled.div`
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    @media ${device.sm} {
        font-size: 14px;
        line-height: 20px;
    }
`
const CloseButton = styled.div`
    display: none;
    @media ${device.lg} {
        display: block;
        position: absolute;
        top: 20px;
        right: 20px;
        width: 16px;
        height: 16px;
        cursor: pointer;
    }
`

const modalStyles = {
    overlay: {
        display: "flex",
        flexWrap: 'wrap',
        justifyContent: "flex-end",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        // overflowY: "auto",
        width: "100%",
        zIndex: '10001',
        cursor: `url(${cursor}), auto`,
        height: '100vh'
    },
    content: {
        padding: 0,
        border: 0,
        cursor: 'default',
        
    }
};

const BrandEssencePopup = ({intl, togglePopupScreen, popupOpen}) => {
    const closeIcon = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.5455 0L16 1.45455L9.454 8L16 14.5455L14.5455 16L8 9.454L1.45455 16L0 14.5455L6.545 8L0 1.45455L1.45455 0L8 6.546L14.5455 0Z" fill="white"/>
    </svg>

    useEffect(() => {
        popupOpen
            && window.scrollTo({top: 0})
    }, [popupOpen])
    
    return (
        <>
            <Modal
                closeTimeoutMS={400}
                isOpen={popupOpen}
                onRequestClose={togglePopupScreen}
                style={modalStyles}
                contentLabel="Modal"
                className="ReactModal__BrandEssence"  
                >
                <HeaderPopup>
                    <PlainImage src="popup/intro_img@2x.jpg" last="xs" alt="" />
                    {/* <PlainImage src="popup/hero_desktop@2x.jpg" last="xs" alt="" /> */}
                    <HeaderWrapper>
                        <HeaderTitle>{intl.formatMessage({ id: 'popup_brand_essence_title' })}</HeaderTitle>
                        <HeaderSubTitle><FormattedHTMLMessage id='popup_brand_essence_subtitle' /></HeaderSubTitle>
                    </HeaderWrapper>
                    <CloseButton onClick={() => togglePopupScreen()}>{closeIcon}</CloseButton>
                </HeaderPopup>
                <ContentBlock>
                    <ContentSubBlock>
                        <BlockTitle>{intl.formatMessage({ id: 'popup_brand_essence_0_title' })}</BlockTitle>
                        <BlockParagraphLast>{intl.formatMessage({ id: 'popup_brand_essence_0_1' })}</BlockParagraphLast>
                    </ContentSubBlock>
                    <ContentSubBlock>
                        <BlockTitle>{intl.formatMessage({ id: 'popup_brand_essence_1_title' })}</BlockTitle>
                        <BlockParagraph>{intl.formatMessage({ id: 'popup_brand_essence_1_1' })}</BlockParagraph>
                        <BlockParagraph>{intl.formatMessage({ id: 'popup_brand_essence_1_2' })}</BlockParagraph>
                        <BlockParagraph>{intl.formatMessage({ id: 'popup_brand_essence_1_3' })}</BlockParagraph>
                        <BlockParagraphLast>{intl.formatMessage({ id: 'popup_brand_essence_1_4' })}</BlockParagraphLast>
                    </ContentSubBlock>
                    <ContentSubBlock>
                        <BlockTitle>{intl.formatMessage({ id: 'popup_brand_essence_2_title' })}</BlockTitle>
                        <BlockParagraph>{intl.formatMessage({ id: 'popup_brand_essence_2_1' })}</BlockParagraph>
                        <BlockParagraph>{intl.formatMessage({ id: 'popup_brand_essence_2_2' })}</BlockParagraph>
                        <BlockParagraphLast>{intl.formatMessage({ id: 'popup_brand_essence_2_3' })}</BlockParagraphLast>
                    </ContentSubBlock>
                    <ContentSubBlock>
                        <BlockTitle>{intl.formatMessage({ id: 'popup_brand_essence_3_title' })}</BlockTitle>
                        <BlockParagraphLast>{intl.formatMessage({ id: 'popup_brand_essence_3_1' })}</BlockParagraphLast>
                    </ContentSubBlock>
                    <BackButtonWithIcon onClick={() => togglePopupScreen()}>{intl.formatMessage({ id: 'popup_brand_essence_bottom_btn' })}</BackButtonWithIcon>
                </ContentBlock>
            </Modal>
            {popupOpen && <ChevronButton onClick={togglePopupScreen} />}
        </>
    )
}

export default BrandEssencePopup


